<script>
import { mapActions, mapGetters } from "vuex";

import orderSchedulerHelper from "@/utils/helpers/orderSchedulerHelper";

import currencyMixin from "@/mixins/generic/currencyMixin";

import pricingHelper from "@/utils/helpers/pricingHelper";
import couponHelper from "@/utils/helpers/coupon";

export default {
  mixins: [currencyMixin],

  props: {
    searchFlow: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    ...mapActions("orderScheduler", [
      "setDuration",
      "unsetScheduleEvent",
      "requestProfessionalsAvailable"
    ]),

    selectedDuration(duration) {
      if (this.searchFlow) {
        this.unsetScheduleEvent();
      }

      this.setDuration(this.duration === duration ? null : duration);

      if (this.searchFlow) {
        this.requestProfessionalsAvailable();
      }
    },

    availableDuration(duration) {
      return this.availableDurations.includes(duration);
    },

    pricing(duration) {
      return pricingHelper.calculatePricing(this.address, duration);
    },

    pricingWithDiscount(duration) {
      if (!this.professional || !this.professional.active_coupon) {
        return null;
      }

      return couponHelper.applyDiscount(
        this.pricing(duration),
        this.professional.active_coupon
      );
    }
  },

  computed: {
    ...mapGetters("orderScheduler", [
      "address",
      "duration",
      "initialHour",
      "finalHour",
      "professional"
    ]),

    purchasableDurations: function() {
      return orderSchedulerHelper.purchasableDurations();
    },

    availableDurations: function() {
      return orderSchedulerHelper.nextAvailableDurations(
        this.initialHour,
        this.searchFlow ? null : this.finalHour
      );
    }
  },

  filters: {
    durationFilter(duration) {
      return `${duration} hora` + (duration > 1 ? "s" : "");
    },

    hourFilter(hour) {
      return (hour < 10 ? "0" : "") + `${hour}h`;
    }
  }
};
</script>

<template>
  <div class="durations">
    <div class="available-durations">
      <template v-for="purchasableDuration in purchasableDurations">
        <div
          v-if="availableDuration(purchasableDuration)"
          class="duration"
          :key="purchasableDuration"
          @click="selectedDuration(purchasableDuration)"
          :class="{'selected': purchasableDuration === duration}"
        >
          <span class="duration-time">
            {{ purchasableDuration | durationFilter }}
          </span>

          <span class="range" v-if="initialHour">
            dàs <b>{{ initialHour | hourFilter }}</b> até às <b>{{ initialHour + purchasableDuration | hourFilter }}</b>
          </span>

          <span class="range">
            valor <b>{{ pricingWithDiscount(purchasableDuration) || pricing(purchasableDuration) | toCurrency }}</b>
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.available-durations {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  grid-gap: 16px;
}

.duration {
  width: 110px;
  padding: 8px 12px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  border: solid 1px #e2e2e2;
  border-radius: 2px;
  color: #424242;
  transition: background-color 0.25s ease-in-out;
  user-select: none;
  cursor: pointer;
}

.selected {
  background-color: #603285;
  color: #fff;
}

.range {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
}

@media (min-width: 1024px) {
  .duration:hover {
    background-color: #603285;
    color: #fff;
    opacity: 0.75;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalFilters/DurationPicker.vue